import React from "react";
import { FaStar } from "react-icons/fa";

const WalmartProductCard = ({ product, onClick, onRemove, createdAt }) => {
  console.log("walmart product", product);
  const image =
    product.main_image || (product.images && product.images[0]) || "";
  const price = product.price || {};

  const handleCardClick = () => {
    if (onClick) {
      onClick();
    } else if (product.link) {
      window.open(product.link, "_blank");
    }
  };

  return (
    <div
      onClick={handleCardClick}
      className="bg-secondary-bg border border-border rounded-xl overflow-hidden hover:border-primary/50 transition-all duration-300 cursor-pointer hover:shadow-lg hover:shadow-primary/10 group"
    >
      {/* Product Image */}
      <div className="relative bg-white p-4 h-48 flex items-center justify-center overflow-hidden">
        {image ? (
          <img
            src={image}
            alt={product.title || "Product"}
            className="max-h-full max-w-full object-contain group-hover:scale-105 transition-transform duration-300"
          />
        ) : (
          <div className="text-gray-400 text-xs">No image</div>
        )}
        {/* Platform badge */}
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-full text-[10px] font-semibold bg-blue-500 text-white shadow-sm">
          Walmart
        </span>
      </div>

      {/* Product Details */}
      <div className="p-4">
        {/* Brand & Category */}
        <div className="flex items-center justify-between gap-2 mb-2">
          <div className="flex items-center gap-2 flex-1 min-w-0">
            <span className="text-primary text-xs font-semibold">
              {product.brand || "N/A"}
            </span>
            <span className="text-gray-600 text-xs">•</span>
            <span className="text-gray-500 text-xs truncate">
              {product.category || "N/A"}
            </span>
          </div>
        </div>

        {/* Title */}
        <h3 className="text-white font-semibold text-sm mb-3 line-clamp-2 min-h-[2.5rem]">
          {product.title || "Product Name Unavailable"}
        </h3>

        {/* Rating */}
        {product.rating && (
          <div className="flex items-center gap-2 mb-3">
            <div className="flex items-center gap-1">
              <FaStar className="text-yellow-500 text-sm" />
              <span className="text-white font-semibold text-sm">
                {product.rating}
              </span>
            </div>
          </div>
        )}

        {/* Price */}
        <div className="mb-3">
          <div className="flex items-baseline gap-2">
            {price.current != null && (
              <span className="text-lg font-bold text-primary-light">
                {price.currency || "USD"} {price.current}
              </span>
            )}
            {price.was != null && price.was !== price.current && (
              <span className="text-xs line-through text-gray-500">
                {price.currency || "USD"} {price.was}
              </span>
            )}
          </div>
        </div>

        {/* Badges */}
        {product.badges && product.badges.length > 0 && (
          <div className="flex flex-wrap gap-1 mb-3">
            {product.badges.map((badge, idx) => (
              <span
                key={badge.id || idx}
                className="px-2 py-0.5 rounded-md bg-primary-bg text-[10px] font-semibold text-primary-light"
              >
                {badge.name || badge.key || badge.id}
              </span>
            ))}
          </div>
        )}

        {/* IDs & Date */}
        <div className="pt-3 border-t border-border space-y-2">
          <div className="flex items-center justify-between">
            <span className="text-gray-400 text-xs">Walmart ID:</span>
            <span className="text-white font-semibold text-sm font-mono">
              {product.product_id || "N/A"}
            </span>
          </div>
          {createdAt && (
            <div className="flex items-center justify-between">
              <span className="text-gray-400 text-xs"></span>
              <span className="text-gray-300 text-xs">
                {new Date(createdAt).toLocaleDateString("en-US", {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                })}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WalmartProductCard;

